import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function DealershipTemplatesCtrl (
  $scope,
  $state,
  $translate,
  workshopAPI,
  tableApi,
  templates
) {
  $scope.tableCacheKey = 'dealershipTemplates';
  $scope.templates     = templates;

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'find_description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'make',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        field : 'model',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        field : 'group_or_franchise_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.FRANCHISE.GROUP_FRANCHISE')
        }
      },
      {
        field : 'body_type',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BODY_TYPE')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInspection(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('INSPECTIONS_SPACE.TEMPLATES.NO_TEMPLATES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vehicle_templates/count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'find_description'
    })
  };

  $scope.getTemplates = ( params ) => {
    return workshopAPI.get('/vehicle_templates', [
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(templates => {
      $scope.templates = templates;

      return templates;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInspection(event.row);
  };

  $scope.viewInspection = function (template) {
    $state.go('app.dealership.template', {
      id: template.id
    });
  };
};